module.exports = __webpack_public_path__ + "135efd8b537c4e1f9e66771f46a07505.svg";